import { FileSharingAccountDTO } from "../DTO/fileSharingAccountDTO";

export class FileSharingAccount{
    public id!: number;
    public customerId!: number;
    public type!: string;
    public accountEmail!: string;
    public folderPath!: string;
    public disabled!: boolean;
    public added!: Date;
    public edited!: Date;

    public static mapFromDTO(param: FileSharingAccountDTO): FileSharingAccount{
        if(!param) throw new Error("parameter is null")
        let obj = new FileSharingAccount();
        try{
            obj.id = param.id;
            obj.customerId = param.customerId;
            obj.type = param.type;
            obj.accountEmail = param.accountEmail;
            obj.folderPath = param.folderPath;
            obj.disabled = param.disabled;
            if(param.added)obj.added = new Date(param.added);
            if(param.edited)obj.edited = new Date(param.edited);
        }
        catch(e){
            console.log(e);
        }
        return obj;
    }

    public static mapToDTO(param: FileSharingAccount): FileSharingAccountDTO{
        if(!param) throw new Error("parameter is null")
        let dto = new FileSharingAccountDTO();
        try{
            dto.id = param.id;
            dto.customerId = param.customerId;
            dto.type = param.type;
            dto.accountEmail = param.accountEmail;
            dto.folderPath = param.folderPath;
            dto.disabled = param.disabled;
            if(param.added)dto.added = param.added.toISOString();
            if(param.edited)dto.edited = param.edited.toISOString();
        } 
        catch(e){
            console.log(e);
        }
        return dto;
    }
}